import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private prefix: string = './assets/i18n/',
    private suffix: string = '.json',
    private version: number = 1
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const url = `${this.prefix}${lang}${this.suffix}?v=${this.version}`;
    return this.http.get(url).pipe(
      map(res => res) // optionally transform if needed
    );
  }
}